import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import MaskingTape from "../components/scrapbook/MaskingTape";
import { PrimaryButton } from "../components/scrapbook/PrimaryButton";

const NotFound = () => (
    <main
        data-testid="not-found-page"
        className="min-h-[80vh] flex flex-col items-center justify-center px-6 pt-24"
    >
        <div className="relative bg-white border border-neutral-200 scrap-shadow p-12 rotate-[-1deg] max-w-lg text-center">
            <MaskingTape
                color="yellow"
                className="-top-4 left-1/2 -translate-x-1/2 w-36 h-8"
            />
            <p className="font-marker text-7xl text-marker-red leading-none">
                404
            </p>
            <h1 className="font-editorial text-3xl text-ink mt-3">
                This page didn&apos;t pop in.
            </h1>
            <p className="font-handwriting text-xl text-ink-light mt-3">
                Maybe it ghosted. Let&apos;s head back.
            </p>
            <div className="mt-7">
                <PrimaryButton href="/" testId="not-found-home-cta">
                    <HomeIcon size={18} strokeWidth={2.5} /> Back home
                </PrimaryButton>
            </div>
        </div>
    </main>
);

export default NotFound;
